import { render, staticRenderFns } from "./SubscriptionList.vue?vue&type=template&id=ed40678e&"
import script from "./SubscriptionList.vue?vue&type=script&lang=js&"
export * from "./SubscriptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports